var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLessonBlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5 3V8H14.5V3H9.5ZM8.5 0C7.39543 0 6.5 0.895431 6.5 2V9C6.5 10.1046 7.39543 11 8.5 11H15.5C16.6046 11 17.5 10.1046 17.5 9V2C17.5 0.895431 16.6046 0 15.5 0H8.5ZM3 16V21H8V16H3ZM2 13C0.895431 13 0 13.8954 0 15V22C0 23.1046 0.895431 24 2 24H9C10.1046 24 11 23.1046 11 22V15C11 13.8954 10.1046 13 9 13H2ZM16 21V16H21V21H16ZM13 15C13 13.8954 13.8954 13 15 13H22C23.1046 13 24 13.8954 24 15V22C24 23.1046 23.1046 24 22 24H15C13.8954 24 13 23.1046 13 22V15Z",
    fill: "#FF6633"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLessonBlock);
export default __webpack_public_path__ + "static/media/lesson-block.b15d2225efe05f4a309530ef209a62e3.svg";
export { ForwardRef as ReactComponent };